import type {
  ApiResponse,
  ContractListItemDetailDTO,
  ContractListItemDTO,
  ContractListParams,
  PageResponse,
} from "@/types/apis";
import request from "@/utils/request";

/** 采购合同列表查询 */
export function getPurchaseContractList(data: ContractListParams) {
  return request.post<PageResponse<ContractListItemDTO>>(
    "/purchase/contract/page",
    data,
  );
}

/** 采购合同详情查询 */
export function getPurchaseContractDetail(id: number) {
  return request.get<ApiResponse<ContractListItemDetailDTO>>(
    `/purchase/contract/getInfoById/${id}`,
  );
}

/** 删除采购合同 */
export function deletePurchaseContract(id: number) {
  return request.delete<ApiResponse>(`/purchase/contract/removeById/${id}`);
}
